module.exports = __webpack_public_path__ + "img/icon17.4f80da84.png";